/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BulkDeleteDraftArticleRequest } from '../../models/bulk-delete-draft-article-request';

export interface BulkDeleteDraftArticle$Params {
      body: BulkDeleteDraftArticleRequest
}

export function bulkDeleteDraftArticle(http: HttpClient, rootUrl: string, params: BulkDeleteDraftArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bulkDeleteDraftArticle.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

bulkDeleteDraftArticle.PATH = '/v0/draft-articles/bulk-delete';
